import React, { Component, PureComponent  } from 'react';
import { inject, observer } from 'mobx-react';
import { LineTableEvent } from './lineTableEvent';
import FavouriteStar from '../favouriteStar/';

class LineTableItem extends Component {

  // shouldComponentUpdate(nextProps) {
  //   return (this.props.games.length != nextProps.games.length);
  // }

  render() {
    return (
      this.props.games.map((item, id) =>
        <LineTableEvent key={id} id={item} idx={id} lg={this.props.games.length}/>
      )
    )
  }
}

class LeagueHead extends Component{

  shouldComponentUpdate(nextProps) {
    if (this.props.status != nextProps.status || this.props.r != nextProps.r ) {
      return true;
    }
    return false;
  }

  render() {
    const { mode, status, r, toogleShow, toogleShowItems, name } = this.props;
    return (
      <tr className="l-tr l-t-tr-1">
        <th className={`l-td l-td-s-${this.props.sportID} l-s-r-${this.props.sportID}`} colSpan={20}>

          <div className="l-td-line">
            <FavouriteStar type={2} id={this.props.id} />
            <div className="l-d l-d-line" >
              {!status && !!r && mode == 'line' &&
                <div className="l-t-a-i" onClick={toogleShow} title="Развернуть росписи">
                  <div className="l-t-a-i-i">
                    <span className="f-s-ico-lines_open"></span>
                  </div>
                </div>}
              <div className={`l-t-i-i ${status ? 'l-t-i-i-a' : ''}`} onClick={toogleShowItems}>
                <div className="l-t-i-i-i">
                  <span className="f-s-ico-arrow_buttom_1" />
                </div>
              </div>
            </div>
            <a className="l-th-name" > {`${this.props.sportName}. ${name}`} </a>
          </div>
        </th>
      </tr>
    );
  }
}

@inject('lineStore')
@observer
export default class LineTable extends Component {
  constructor(props) {
    super(props)
  }

  handleShowItems = () => {
    this.props.lineStore.line.toogleShowTableItems(this.props.id);
  }

  handleShowDop = (evt) => {
    evt.stopPropagation();
    this.props.lineStore.line.toogleShowDop(this.props.id, 0);
  }

  render() {
    const {id, style, lineStore} = this.props;

    if (!this.props.lineStore.line.lineLeague.has(id)) return null;

    const {name, r, show, games, sid} = lineStore.line.lineLeague.get(id);

    return (
      <table className="l-t" id={`segment_${id}`} style={style}>
        <tbody>
          <LeagueHead toogleShow={this.handleShowDop} id={id} sportID={sid} sportName={this.props.sportName} toogleShowItems={() => this.handleShowItems()} name={name} r={r} status={show} mode={this.props.lineStore.line.mode}/>
          { !show ? <LineTableItem games={games}/> : null }
        </tbody>
      </table>
      )
  }
}


// WEBPACK FOOTER //
// ./src/components/line/lineTable.js